import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionA');
    const { locale } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571004129/a1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571004650/b1.jpg',
            section: (
                <div className="SectionA-a">
                    <div className="SectionA-a-icon">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722864331577/c1.png" />
                    </div>
                    <div className="SectionA-a-title">{t('a_title')}</div>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724817516851/X-boost-R3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724817516685/X-boost_R3%E6%88%B7%E5%A4%96.jpg',
            section: (
                <div className="SectionA-a">
                    <div className="SectionA-a-icon">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722864331577/c1.png" />
                    </div>
                    <div className="SectionA-a-title">{t('b_title')}</div>
                </div>
            ),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={listA} />
            {IS_EU_SITES && <EfSpec className="x2" />}
        </div>
    );
}
